// `avatar restore [--backup <name>] [--list]` — Command 08 spec.
// Restore .claude/pack/ from a previous backup snapshot.
import type { Command } from "commander";
import { notImplementedYet } from "../lib/not-implemented-stub.js";

export function registerRestoreCommand(program: Command): void {
  program
    .command("restore")
    .description("Khôi phục .claude/pack/ từ backup (M08)")
    .option("--backup <name>", "Tên backup folder trong .claude/_backup/")
    .option("--list", "Liệt kê các backup hiện có")
    .action(notImplementedYet("restore", "Milestone 08"));
}
